import { ADMIN_AUTH_FLAG_KEY, clearAdminJwt } from "./authToken";

let redirectScheduled = false;

export function clearAdminSessionClientSide() {
  clearAdminJwt();
  try {
    localStorage.removeItem(ADMIN_AUTH_FLAG_KEY);
  } catch {
    // ignore
  }
}

function requestSentBearerAuth(init) {
  if (!init || typeof init !== "object") return false;
  const h = init.headers;
  if (h == null) return false;
  if (typeof Headers !== "undefined" && h instanceof Headers) {
    const v = h.get("Authorization") || h.get("authorization");
    return typeof v === "string" && /^Bearer\s/i.test(v);
  }
  if (typeof h === "object") {
    const auth =
      h.Authorization ??
      h.authorization ??
      Object.entries(h).find(([k]) => String(k).toLowerCase() === "authorization")?.[1];
    return typeof auth === "string" && /^Bearer\s/i.test(auth);
  }
  return false;
}

export async function adminAuthedFetch(input, init) {
  const res = await fetch(input, init);
  if (res.status !== 401 || !requestSentBearerAuth(init)) {
    return res;
  }
  clearAdminSessionClientSide();
  if (typeof window !== "undefined" && !redirectScheduled) {
    const p = window.location.pathname || "";
    if (!p.toLowerCase().startsWith("/admin/login")) {
      redirectScheduled = true;
      window.location.replace(`${window.location.origin}/admin/login`);
    }
  }
  return res;
}
